import { gql } from "@apollo/client";

export const CHECK_SESSION = gql`
  query {
    checkSession {
      operatorAccountId
      operator {
        operatorId
        company
        operatorRole {
          operatorRoleId
          accessPermissions
        }
      }
      username
      userEmail
      accessPermissions
      adminAccess
      operatorAccountRoleId
      active
    }
  }
`;

export const REFRESH_OPERATOR_TOKEN = gql`
  query {
    refreshOperatorToken
  }
`;

export const AUTHENTICATE_OPERATOR_ACCOUNT = gql`
  query ($userEmail: String!, $password: String!) {
    authenticateOperatorAccount(userEmail: $userEmail, password: $password) {
      operatorAccountId
      operator {
        operatorId
        company
        operatorRole {
          operatorRoleId
          accessPermissions
        }
      }
      username
      password
      userEmail
      accessPermissions
      adminAccess
      operatorAccountRoleId
      active
    }
  }
`;
export const ALL_OPERATOR_ACCOUNTS = gql`
  {
    allOperatorAccounts {
      operatorAccountId
      operator {
        company
      }
      userEmail
      username
      operatorAccountRoleId
      accessPermissions
    }
  }
`;

export const UPDATE_USER_ACCESS_PERMISSION = gql`
  mutation ($userAccessPermissionArgs: UpdateUserAccessPermissionObject!) {
    updateUserAccessPermission(
      userAccessPermissionArgs: $userAccessPermissionArgs
    ) {
      userAccessPermission {
        operatorAccountId
      }
    }
  }
`;

export const LOGOUT_OPERATOR_ACCOUNT = gql`
  mutation {
    logoutOperatorAccount {
      success
      message
    }
  }
`;

export const OPERATOR_ACCOUNTS_BY_OPERATOR_ID = gql`
  query ($operatorId: ID!) {
    operatorAccountByOperatorId(operatorId: $operatorId) {
      operatorAccountId
      userEmail
      username
      accessPermissions
    }
  }
`;
export const OPERATOR_ACCOUNTS_BY_FILTER = gql`
  query (
    $operatorId: ID!
    $active: Boolean
    $operatorAccountRoleId: Int
    $userEmail: String
  ) {
    operatorAccountsByFilter(
      operatorId: $operatorId
      active: $active
      operatorAccountRoleId: $operatorAccountRoleId
      userEmail: $userEmail
    ) {
      operatorAccountId
      operator {
        operatorId
        company
        __typename
      }
      username
      userMobile
      userEmail
      operatorAccountRoleId
      active
      editablePartnerFees
      editableUserFees
      editableSellerFees
      accessPermissions
      __typename
    }
  }
`;
export const OPERATORS = gql`
  {
    operators {
      operatorId
      company
    }
  }
`;

export const UPDATE_OPERATOR_ACCOUNTS_MUTATION = gql`
  mutation ($operatorAccountId: ID!, $inputData: OperatorAccountInput!) {
    updateOperatorAcccountMutation(
      operatorAccountId: $operatorAccountId
      inputData: $inputData
    ) {
      operatorAccount {
        operatorAccountId
        username
      }
    }
  }
`;

export const CREATE_OPERATOR_ACCOUNT_MUTATION = gql`
  mutation (
    $operatorId: ID!
    $password: String!
    $userEmail: String!
    $username: String!
    $userMobile: String!
    $operatorAccountRoleId: ID!
    $accessPermissions: String
    $active: Boolean!
    $adminAccess: Boolean
  ) {
    createOperatorAcccountMutation(
      operatorId: $operatorId
      password: $password
      userEmail: $userEmail
      username: $username
      userMobile: $userMobile
      operatorAccountRoleId: $operatorAccountRoleId
      accessPermissions: $accessPermissions
      active: $active
      adminAccess: $adminAccess
    ) {
      operatorAccount {
        operatorAccountId
        operatorAccountId
      }
    }
  }
`;
